import { Link, Stack, Typography } from '@mui/material';
import { ItemDetail } from './item-types';
import { GridContainer, GridItem } from '../shared/ui-extension';
import { printRoundedNumber } from '../../shared/utils';

interface SubstituteItemProps {
  substitute: ItemDetail;
}

export default function SubstituteItem(props: SubstituteItemProps) {
  const { substitute } = props;
  return (
    <Stack>
      <GridContainer alignItems='flex-start'>
        <GridItem xs={6}>
          <Link
            href={`/item?itemId=${substitute.item_id}`}
            target='_blank'
            rel='noopener'
          >
            <Typography>{substitute.item_id}</Typography>
          </Link>
        </GridItem>
        <GridItem xs={6}>
          <SubstituteItemTag
            label='QOH:'
            value={`${
              printRoundedNumber(substitute.qty_on_hand, 0)
                ? printRoundedNumber(substitute.qty_on_hand, 0)
                : 'N/A'
            }`}
          />
          <SubstituteItemTag
            label='Available:'
            value={`${
              printRoundedNumber(substitute.qty_avail, 0)
                ? printRoundedNumber(substitute.qty_avail, 0)
                : 'N/A'
            }`}
          />
        </GridItem>
      </GridContainer>
    </Stack>
  );
}

function SubstituteItemTag({ label, value }: { label: string; value: string }) {
  return (
    <GridContainer>
      <GridItem xs={6}>
        <Typography variant='body2'>{label}</Typography>
      </GridItem>
      <GridItem xs={6}>
        <Typography variant='body2'>{value}</Typography>
      </GridItem>
    </GridContainer>
  );
}
